import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function SubCategoryPage() {
    const columns = useMemo(() => [
        { key: 'name', label: 'Sub Category' },
        { key: 'parent_name', label: 'Category' },
        { key: 'code', label: 'Code' },
        { key: 'description', label: 'Description' },
        { key: 'usage_count', label: 'Products' },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Sub Category"
            type="sub-category"
            columns={columns}
            fields={[
                { name: 'name', label: 'Sub Category Name' },
                {
                    name: 'parent_id',
                    label: 'Category',
                    type: 'select',
                    options: (options) => (options.category || []).map((item) => ({ value: String(item.id), label: item.name })),
                },
                { name: 'code', label: 'Code', placeholder: 'Optional internal code' },
                { name: 'slug', label: 'Slug', placeholder: 'Auto from name if empty' },
                { name: 'description', label: 'Description', type: 'textarea' },
            ]}
            buildPayload={(form, options) => {
                const parent = (options.category || []).find((item) => String(item.id) === String(form.parent_id));
                return {
                    name: form.name,
                    slug: form.slug,
                    code: form.code,
                    description: form.description,
                    status: form.status,
                    metadata: {
                        parent_id: form.parent_id ? Number(form.parent_id) : null,
                        parent_name: parent?.name || null,
                    },
                };
            }}
        />
    );
}
